import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

interface HealthRes {
  ok: boolean;
  environment: string;
  time: number;
  bindings: Record<string, boolean>;
}

export function SystemPage() {
  const { data } = useQuery({
    queryKey: ["admin", "health"],
    queryFn: () => api.get<HealthRes>("/api/health"),
    refetchInterval: 5_000,
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">System</h1>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="pfh-card">
          <h2 className="pfh-heading">Worker</h2>
          <div className="mt-2 text-sm">
            <div className="pfh-kv">
              <span className="text-muted-foreground">env</span>
              <span className="pfh-value">{data?.environment ?? "?"}</span>
            </div>
            <div className="pfh-kv">
              <span className="text-muted-foreground">last check</span>
              <span className="pfh-value">
                {data ? new Date(data.time).toLocaleTimeString() : "—"}
              </span>
            </div>
          </div>
        </div>
        <div className="pfh-card">
          <h2 className="pfh-heading">Bindings</h2>
          <ul className="mt-2 text-xs">
            {data
              ? Object.entries(data.bindings).map(([k, v]) => (
                  <li key={k} className="pfh-kv">
                    <span className="text-muted-foreground">{k}</span>
                    <span className={v ? "text-green-400" : "text-destructive"}>{v ? "ok" : "missing"}</span>
                  </li>
                ))
              : null}
          </ul>
        </div>
        <div className="pfh-card">
          <h2 className="pfh-heading">Actions</h2>
          <div className="mt-2 flex flex-col gap-2 text-sm">
            <button className="rounded-md border border-border px-3 py-2 text-left hover:bg-muted">
              Trigger intel: rules
            </button>
            <button className="rounded-md border border-border px-3 py-2 text-left hover:bg-muted">
              Trigger intel: pricing
            </button>
            <button className="rounded-md border border-border px-3 py-2 text-left hover:bg-muted">
              Trigger news calendar refresh
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
